const Container = ({ children, fullPage, className }) => {
  if (fullPage) {
    return <div className={`lg:px-8 ${className || ''}`}>{children}</div>;
  } else {
    return (
      <div
        className={`px-auto max-w-container container px-4 sm:px-10 lg:px-16 2xl:px-0 ${className || ''}`}
      >
        {children}
      </div>
    );
  }
};
export default Container;
